import createTypes from 'redux-create-action-types';

export default createTypes(
  // CUSTOM
  'SYNC_SET_CHAT_INFORMATION',
  'SYNC_RESET_CHAT_INFORMATION'
);
